import { IResultExamScheduleListDAO } from '../Modules/ExamSchedule/DAO/examSchedule.dao';
import instance from './interceptor';

export const getExamScheduleAPI = async (): Promise<
  IResultExamScheduleListDAO[]
> => {
  const { data } = await instance.get(`/Candidate/examschedule`);
  return data;
};
